import React from 'react';

import { TrackingStatus, TrackingStatusEnum } from '@ael/core-api';
import classNames from 'classnames';

import './MenuSectionContentItemLabel.scss';

type MenuSectionContentItemLabelProps = {
  title?: string;
  isExpanded?: boolean;
  trackingStatus?: TrackingStatus;
  onClick?: () => void;
};

export const MenuSectionContentItemLabel: React.FunctionComponent<MenuSectionContentItemLabelProps> = ({
  title,
  isExpanded,
  trackingStatus,
  onClick,
}) => {
  const isCompleted = trackingStatus === TrackingStatusEnum.Completed;
  const isInProgress = trackingStatus === TrackingStatusEnum.InProgress;
  return (
    <div
      className={classNames('menu-section-content-item-label', {
        'menu-section-content-item-label--expanded': isExpanded,
        'menu-section-content-item-label--locked': !(isCompleted || isInProgress),
      })}
      onClick={onClick}
    >
      <div className="menu-section-content-item-label__section-line" />
      <div
        className={classNames('menu-section-content-item-label__indicator', {
          'menu-section-content-item-label__indicator--expanded': isExpanded,
          'menu-section-content-item-label__indicator--completed': isCompleted,
          'menu-section-content-item-label__indicator--in-progress': isInProgress,
        })}
      />
      <div className="menu-section-content-item-label__title">{title}</div>
    </div>
  );
};
